module.exports = __webpack_public_path__ + "img/c_4.6f9ebd18.png";